import React from 'react'
import "./skills.css"
import Backend from './backend'
import Frontend from './frontend'
const skills = () => {
  return (
   <section className='skills section' id='skills'>
    <h2 className='section__title'>Skills</h2>
    <span className='section__subtitle'>My Technical Level</span>
    <div className="skills__container container grid">
        <Backend></Backend>
        <Frontend></Frontend>
    </div>
   </section>
  )
}

export default skills